module.exports = __webpack_public_path__ + "static/media/tennis_logo_small.b7686c2f.png";